export default __webpack_public_path__ + "static/media/Youtub -logo.12cda458.png";